import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BooleanFilter, NumberFilter, RadioFilter, SelectFilter, StringFilter, DateFilter } from '@models/filter-types';
import { LookupItem } from '@models/lookup';
import { FilterOption } from '@models/rate-card/rate-card';

@Component({
    selector: 'app-save-report-popup',
    templateUrl: './save-report-popup.component.html',
    styleUrls: ['./save-report-popup.component.scss'],
    standalone: false,
})
export class SaveReportPopupComponent implements OnInit {
    isLoading = false;
    filters: {
        nameFilter: StringFilter;
        saveAsGlobalFilter: BooleanFilter;
        saveMetricSelectionsFilter?: BooleanFilter;
        dateRangeOptionsFilter?: RadioFilter<FilterOption>;
        periodSelectFilter?: SelectFilter<LookupItem>;
        quickDateOptionsSelectFilter?: SelectFilter<LookupItem>;
        startingPeriodFilter?: SelectFilter<string>;
        numberOfPeriodsFilter?: NumberFilter;
        addAsFavoriteFilter: BooleanFilter;
        showMetrics?: boolean;
        startDateSelectFilter: DateFilter;
        endDateSelectFilter: DateFilter;
        politicalDateLabel?: string;
    };
    allFiltersSelected: boolean;
    isEditMode: boolean;
    showSaveMetricSelections: boolean;

    constructor(
        public dialogRef: MatDialogRef<SaveReportPopupComponent>,
        public changeDetectorRef: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA)
        data: {
            filters: {
                nameFilter: StringFilter;
                saveAsGlobalFilter: BooleanFilter;
                saveMetricSelectionsFilter?: BooleanFilter;
                dateRangeOptionsFilter?: RadioFilter<FilterOption>;
                periodSelectFilter?: SelectFilter<LookupItem>;
                quickDateOptionsSelectFilter?: SelectFilter<LookupItem>;
                startingPeriodFilter?: SelectFilter<string>;
                numberOfPeriodsFilter?: NumberFilter;
                addAsFavoriteFilter: BooleanFilter;
                showMetrics?: boolean;
                startDateSelectFilter: DateFilter;
                endDateSelectFilter: DateFilter;
                politicalDateLabel?: string;
            };
            allFiltersSelectedCheck: boolean;
            isEditMode: boolean;
            showSaveMetricSelections?: boolean;
        },
    ) {
        this.filters = data.filters;
        this.allFiltersSelected = data.allFiltersSelectedCheck;
        this.isEditMode = data.isEditMode;
        this.showSaveMetricSelections = data.showSaveMetricSelections ?? false;
    }

    ngOnInit(): void {
        this.filters.nameFilter.Validate();
    }

    closeDialog() {
        this.dialogRef.close();
    }

    isRollingPeriodsSelected(): boolean {
        return this.filters.dateRangeOptionsFilter?.Value?.name === 'Save Rolling Dates';
    }

    close() {
        let isValidPeriod;
        this.filters.nameFilter.Validate();
        const isValidName = this.filters.nameFilter.isValid;

        if (this.isRollingPeriodsSelected() && this.filters?.numberOfPeriodsFilter) {
            this.filters.numberOfPeriodsFilter.Validate();
            isValidPeriod = this.filters.numberOfPeriodsFilter.isValid;
        } else {
            isValidPeriod = true;
        }

        if (isValidName && isValidPeriod) {
            this.dialogRef.close(this.filters);
        } else {
            console.log('There seems to be a problem with the report name or rolling period');
        }
    }
}
